import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import config from "./config/config-secret.json";
// import { Offline, Online } from "react-detect-offline";

import {
  start,
  initializeTest,
  setKeyAndCode,
  setToErrorStatus,
  setStatus,
  setlanguage,
  changeView,
  setCheatCount,
} from "./actions/assessment";

import { Modal } from "react-bootstrap";
import warningIcon from "./assets/img/icon-warning.svg";

import Header from "./components/Header";
import Welcome from "./components/Welcome";
import Demographic from "./components/Demographic";
import SportDemographic from "./components/SportDemographic";
import Instruction from "./components/Instructions/Instruction";
import Examination from "./components/Examination";
import Ptsd from "./components/Ptsd";
import SessionDetails from "./components/SessionDetails";
import Completed from "./components/Completed";
import TimeExpired from "./components/TimeExpired";

import imgPreloader from "./assets/img/preloader.gif";

import "./App.css";
import "./styles/custom.css";

import { Translate } from "react-redux-i18n";
import { setLocaleWithFallback } from "./actions/i18n";
import IdCapture from "./components/IdCapture";
import IdCaptureInstructions from "./components/IdCaptureInstructions";
import JobApplication from "./components/JobApplication";
import JobApplicationForm1 from "./components/JobApplicationForm1";
import JobApplicationForm2 from "./components/JobApplicationForm2";
import { ToastContainer } from "react-toast";
import MainPracticeTest from "./components/PracticeTests/MainPracticeTest";
import TypingTest from "./components/TypingTest";
import DataEntryTest from "./components/DataEntryTest";
import OpenQuestionInstructions from "./components/OpenQuestionInstructions";
import OpenQuestionForm1 from "./components/OpenQuestionForm1";
import Notice from "./components/Notice";
import Button from "./components/ui/Buttons/Button";

class App extends React.Component {
  state = {
    show_error_modal: false,
    show_key_code_modal: false,
    show_email_verification_modal: false,
    show_language_selection_modal: false,
    modal_message: "",
    key: null,
    code: null,
    tester_id: null,
    email: "",
    validate_email: "",
    portal_name: "",
    lang: "en",
    alt_loader: "",
    online: true,
    languages: [
      {
        code: "en",
        name: "English",
      },
    ],
    redirect_to_url: false,
    redirect_url: "https://www.psymetricsworld.com",
    isTabActive: !document.hidden && document.hasFocus(),
    isWindowChange: false,
    cheatCount:
      parseInt(
        window.localStorage.getItem(
          new URLSearchParams(window.location.search).get("key") +
            "_cheat_count",
        ),
      ) || 0,
  };

  setAppLanguage(lang) {
    this.setState({ lang: lang });
    this.props.setLocaleWithFallback(lang);
    this.props.setlanguage(lang);
  }

  showWarningModal(message, redirect_to_url = false) {
    document.querySelector("#initloader").style.display = "none";
    this.setState({
      show_error_modal: true,
      modal_message: message,
      redirect_to_url: redirect_to_url,
    });
  }

  showInviteCodeModal = () => {
    //this.props.setToErrorStatus(0);
    document.querySelector("#initloader").style.display = "none";
    this.setState({
      show_key_code_modal: true,
    });
  };

  showEmailVerificationModal = () => {
    this.props.setToErrorStatus(0);
    document.querySelector("#initloader").style.display = "none";
    this.setState({
      show_email_verification_modal: true,
      show_language_selection_modal: false,
    });
  };

  showLanguageSelectionModal = () => {
    // this.props.setToErrorStatus(0);
    document.querySelector("#initloader").style.display = "none";
    this.setState({
      show_email_verification_modal: false,
      show_language_selection_modal: true,
    });
  };

  componentDidMount = async () => {
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    window.addEventListener("blur", this.handleWindowBlur);
    window.addEventListener("focus", this.handleWindowFocus);

    var i18n = require("react-redux-i18n").I18n;
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let key = params.get("key");
    let code = params.get("code");

    this.setState({
      alt_loader: i18n.t("loader"),
    });

    if (!!!key || !!!code) {
      document.querySelector("#initloader").style.display = "none";
      return this.showInviteCodeModal();
    }

    /** temporary disable connectivity check */
    // this.interval = setInterval(async () => {
    //     const isOnline = await this.isOnline();

    //     this.setState({
    //        online: isOnline
    //     });
    // }, 5000);

    this.setState({ key, code });
    const is_testing_url = await this.checkIfTestingUrl(key, code);

    if (!is_testing_url) {
      return await this.gererateExamination(key, code);
    } else {
      return this.initTestingUrlVerification(key, code);
    }
  };

  isOnline = async () => {
    if (!window.navigator.onLine) return false;

    let isOnline = true;

    await fetch(config.API_DOMAIN + "/connectivity/ping/", {
      // Check for internet connectivity
      mode: "no-cors",
    })
      .then(() => {
        isOnline = true;
      })
      .catch(() => {
        isOnline = false;
      });

    return isOnline;
  };

  // duplicate method: seems unused. removed?
  checkIfTestingUrl = async (key_code, invite_code) => {
    let is_testing_url = false;
    await axios
      .get(
        config.API_DOMAIN +
          `/v2/examination/testing_url_info/?invite_code=${invite_code}&key_code=${key_code}`,
      )
      .then((response) => {
        if (response.data.success === true) {
          const data = response.data;
          this.state.portal_name = data.portal_name;
          is_testing_url = true;
        }
      });

    return is_testing_url;
  };

  initTestingUrlVerification = async (key_code, invite_code) => {
    this.props.setStatus(99);
    await axios
      .get(
        config.API_DOMAIN +
          `/v2/examination/testing_url_languages/?invite_code=${invite_code}&key_code=${key_code}`,
      )
      .then(async (res) => {
        const response = res.data;
        document.querySelector("#initloader").style.display = "none";

        if (response.success === true) {
          const data = response.data;
          const show_language_selection_modal =
            data.language_selection_enable && data.languages.length > 1;

          this.setState({
            languages: data.languages,
          });

          this.setAppLanguage(data.languages[0].code);

          if (!show_language_selection_modal) {
            return this.showEmailVerificationModal();
          }
          return this.showLanguageSelectionModal();
        }

        // this.setAppLanguage(this.state.lang);
        // this.props.setStatus(0);
        // return await this.gererateExamination(key_code, invite_code, 0, true);
      });

    // return this.showEmailVerificationModal();
  };

  handleCheckInviteCode = async (e) => {
    e.preventDefault();
    const code = this.state.code;

    await axios
      .post(
        config.API_URL + "/questions/generate_examination_by_invite_code/",
        {
          invite_code: code,
        },
      )
      .then(async (res) => {
        const response = res.data;

        if (response.success === false) {
          return this.showWarningModal(
            // response.error_message
            <Translate value="check_error" />,
          );
        }

        const data = response.data;
        this.setAppLanguage(data.language.code);

        document.querySelector("#initloader").style.display = "none";
        this.setState({ show_key_code_modal: false });
        // set app status to started
        this.props.setStatus(0);
        return await this.gererateExamination(
          response.data.key_code,
          response.data.invite_code,
        );
      })
      .catch((error) => {
        console.log(error);
        return this.showWarningModal(<Translate value="alert_error" />);
      });
  };

  handleKeyCodeChange = (e) => {
    this.setState({ code: e.target.value });
  };

  handleEmailVerification = async (e) => {
    const key_code = this.state.key;
    const invite_code = this.state.code;
    const email = this.state.email;

    // const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    // eslint-disable-next-line
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    if (!this.state.email || regex.test(this.state.email) === false) {
      return this.showWarningModal(<Translate value="valid_email" />);
    }

    if (this.state.email !== this.state.validate_email) {
      return this.showWarningModal(<Translate value="diff_email" />);
    }

    await axios
      .get(
        config.API_DOMAIN +
          `/v2/examination/get_testing_url_candidat_by_email/?invite_code=${invite_code}&key_code=${key_code}&email=${email}`,
      )
      .then(async (res) => {
        this.props.setStatus(0);
        const response = res.data;

        document.querySelector("#initloader").style.display = "";
        this.setState({ show_email_verification_modal: false });

        if (response.success === true) {
          const data = response.data;
          this.setAppLanguage(data.lang);
          this.setState({ tester_id: response.data.candidate_id });

          return await this.gererateExamination(
            key_code,
            invite_code,
            response.data.candidate_id,
            true,
          );
        }

        this.setAppLanguage(this.state.lang);
        return await this.gererateExamination(key_code, invite_code, 0, true);
      });
  };

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value });
  };

  handleValidateEmailChange = (e) => {
    this.setState({ validate_email: e.target.value });
  };

  checkIfTestingUrl = async (key_code, invite_code) => {
    let is_testing_url = false;
    await axios
      .get(
        config.API_URL +
          `/questions/testing_url_info/?invite_code=${invite_code}&key_code=${key_code}`,
      )
      .then((response) => {
        if (response.data.success === true) {
          this.setState({ lang: "en" });
          this.props.setLocaleWithFallback("en");

          this.state.portal_name = response.data.data.portal_name;
          is_testing_url = true;
        }
      });

    return is_testing_url;
  };

  gererateExamination = async (
    key,
    code,
    tester_id = 0,
    is_testing_url = false,
  ) => {
    var i18n = require("react-redux-i18n").I18n;
    let local_stored_exam = null;

    if (!is_testing_url) {
      local_stored_exam = localStorage.getItem(key);

      if (local_stored_exam) {
        let local_data = JSON.parse(local_stored_exam);
        tester_id = local_data.tester_id;
      }
    }

    const browser_info = {
      timeOpened: new Date(),
      timezone: new Date().getTimezoneOffset() / 60,
      pageon: window.location.pathname,
      referrer: document.referrer,
      previousSites: window.history.length,
      browserName: window.navigator.appName,
      browserEngine: window.navigator.product,
      browserVersion1a: window.navigator.appVersion,
      browserVersion1b: navigator.userAgent,
      browserLanguage: navigator.language,
      browserOnline: navigator.onLine,
      browserPlatform: navigator.platform,
      ip_info: "Temporarily Disabled IP gathering",
    };

    document.querySelector("#initloader").style.display = "";

    await axios
      .get(config.API_DOMAIN + "/v2/examination/generate/", {
        params: {
          key: key,
          code: code,
          tester_id: tester_id,
          lang: this.state.lang,
        },
      })
      .then((res) => {
        const response = res.data;

        if (response.success === false) {
          if (response?.extra_info?.message_code === "examination_expired") {
            if (response?.extra_info?.redirect_url)
              this.setState({
                redirect_url: response?.extra_info?.redirect_url,
              });
            // i18n.t("examination_expired") always uses the default language here.
            return this.showWarningModal(response.error_message, true);
          }
          if (response?.extra_info?.redirect_url)
            this.setState({ redirect_url: response?.extra_info?.redirect_url });
          return this.showWarningModal(i18n.t("generate_error", true));
        }

        this.props.setKeyAndCode(key, code);

        const data = response.data;
        this.setState({ lang: data.language.code });
        this.props.setLocaleWithFallback(data.language.code);

        let total_questions = 0;
        let approximate_time = 0;
        let demographic_fields = data.demographic_fields;
        let sport_demographic_fields = data.sport_demographic_fields;
        let last_session_info = {};
        let exam_id = data.exam_id;
        let is_completed = data.is_completed;
        let sessions = data.sessions;
        let exams = data.exams;
        let redirect_url = data.redirect_url;
        let platform_logo = data.platform_logo;
        let client_platform_logo = data.client_platform_logo;
        let exam_type = data.exam_type;
        let dist_url = data.dist_url;
        let candidate_consent = data.candidate_consent;
        let enabled_open_question = data.enabled_open_question;
        let open_questions = data.open_questions;
        // let is_expired = data.is_expired;
        tester_id = data.tester_id;

        this.setState({
          alt_loader: i18n.t("loader"),
          redirect_url: redirect_url,
        });

        if (is_completed && exam_type !== 3) {
          return this.showWarningModal(i18n.t("completed"), true);
        }

        if (local_stored_exam) {
          last_session_info = JSON.parse(local_stored_exam);
          exams = last_session_info.exams;
          sessions = last_session_info.sessions;
        } else if (tester_id) {
          last_session_info = JSON.parse(data.last_session_info);
          exams = last_session_info.exams;
          sessions = last_session_info.sessions;
        }

        for (let x = 0; x < exams.length; x++) {
          total_questions += exams[x].questions.length;
          approximate_time += exams[x].time_limit;
        }

        this.props.initializeTest(
          exam_id,
          tester_id,
          demographic_fields,
          sport_demographic_fields,
          sessions,
          exams,
          total_questions,
          approximate_time,
          last_session_info,
          redirect_url,
          dist_url,
          candidate_consent,
          platform_logo,
          client_platform_logo,
          browser_info,
          data.has_security_features,
          data.has_job_application,
          enabled_open_question,
          open_questions,
        );

        document.querySelector("#initloader").style.display = "none";
      })
      .catch((error) => {
        document.querySelector("#initloader").style.display = "";
        console.log(error);
        return this.showWarningModal(i18n.t("generate_error"), true);
      });
  };

  startTypingTest = (is_started) => {
    if (is_started) {
      alert("Start Timer");
    }
  };

  handleVisibilityChange = () => {
    this.checkIfShouldRedirect();
  };

  handleWindowBlur = () => {
    this.checkIfShouldRedirect();
    if (
      ![
        "notice",
        "welcome",
        "demographic",
        "sport_demographic",
        "session_details",
        "open_question_instructions",
        "open_question_form1",
        "job_application",
        "job_application_form1",
        "job_application_form2",
        "id_capture",
        "id_capture_instructions",
        "completed",
      ].includes(this.props.view)
    ) {
      let count = parseInt((this.state.cheatCount += 1));
      window.localStorage.setItem(
        new URLSearchParams(window.location.search).get("key") + "_cheat_count",
        count,
      );
      this.props.setCheatCount(
        parseInt(
          window.localStorage.getItem(
            new URLSearchParams(window.location.search).get("key") +
              "_cheat_count",
          ),
        ),
      );
    }
  };

  handleWindowFocus = () => {
    this.checkIfShouldRedirect();
  };

  checkIfShouldRedirect = () => {
    var i18n = require("react-redux-i18n").I18n;
    if (document.hidden || !document.hasFocus()) {
      this.setState({
        isWindowChange: ![
          "notice",
          "welcome",
          "demographic",
          "sport_demographic",
          "session_details",
          "open_question_instructions",
          "open_question_form1",
          "job_application",
          "job_application_form1",
          "job_application_form2",
          "id_capture",
          "id_capture_instructions",
          "completed",
        ].includes(this.props.view)
          ? true
          : false,
        modal_message: i18n.t("switch_notice"),
      });
    } else {
      this.setState({ isTabActive: true });
    }
  };

  componentWillUnmount() {
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange,
    );
    window.removeEventListener("blur", this.handleWindowBlur);
    window.removeEventListener("focus", this.handleWindowFocus);
  }

  render() {
    const i18n = require("react-redux-i18n").I18n;
    const langugeOptions = this.state.languages.map((option, index) => {
      return (
        <option key={index} value={option.code}>
          {option.name}
        </option>
      );
    });

    return (
      <div className="App">
        <div id="initloader" className="preloader-wrapper">
          <div className="preloader">
            <img src={imgPreloader} alt={this.state.alt_loader} />
          </div>
        </div>

        <div
          id="savingLoader"
          className="preloader-wrapper"
          style={{ display: "none" }}
        >
          <div className="preloader">
            <img src={imgPreloader} alt={this.state.alt_loader} />
            <br />
            <br />
            <p>
              <Translate value="saving" />
            </p>
          </div>
        </div>

        {[
          "job_application_form1",
          "job_application_form2",
          "examination",
          "practice_test",
          "data_entry_test",
          "typing_test",
        ].includes(this.props.view) && (
          <ToastContainer position="top-center" delay={5000} />
        )}

        {this.state.online === true && (
          <div className="main">
            {this.props.assessment.status === 99 ? (
              <div>
                <Header />
                <div className="main container-fluid h-100">
                  <div className="row h-100 justify-content-center align-items-center">
                    <div className="col-12">
                      <div className="container"></div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <Header />
                {this.props.view === "notice" && <Notice />}
                {this.props.view === "welcome" && <Welcome />}
                {this.props.view === "demographic" && <Demographic />}
                {this.props.view === "sport_demographic" && (
                  <SportDemographic />
                )}
                {this.props.view === "session_details" && <SessionDetails />}
                {this.props.view === "open_question_instructions" && (
                  <OpenQuestionInstructions />
                )}
                {this.props.view === "open_question_form1" && (
                  <OpenQuestionForm1 />
                )}
                {this.props.view === "job_application" && <JobApplication />}
                {this.props.view === "job_application_form1" && (
                  <JobApplicationForm1 />
                )}
                {this.props.view === "job_application_form2" && (
                  <JobApplicationForm2 />
                )}
                {this.props.view === "instruction" && <Instruction />}
                {this.props.view === "practice_test" && <MainPracticeTest />}
                {this.props.view === "typing_test" && <TypingTest />}
                {this.props.view === "data_entry_test" && <DataEntryTest />}
                {this.props.view === "ptsd" && <Ptsd />}
                {this.props.view === "examination" && <Examination />}
                {this.props.view === "completed" && <Completed />}
                {this.props.view === "time_expired" && <TimeExpired />}
                {this.props.view === "id_capture" && <IdCapture />}
                {this.props.view === "id_capture_instructions" && (
                  <IdCaptureInstructions />
                )}
              </div>
            )}
          </div>
        )}

        {this.state.online === false && (
          <div className="main container-fluid h-100">
            <div className="row h-100 justify-content-center align-items-center">
              <div className="col-12">
                <div className="container">
                  <div className="row  justify-content-center ">
                    <div className="col-md-6 ">
                      <div className="test-info ">
                        <center>
                          <br />
                          <br />
                          <h1>
                            <Translate value="whoops" />
                          </h1>
                          <br />
                          <br />
                          <h5>
                            <Translate value="no_internet_err" />
                          </h5>
                          <br />
                          <br />
                        </center>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <Modal
          show={this.state.isWindowChange}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <div className="text-center mt-5 mb-5">
              <img src={warningIcon} className="icon" alt={i18n.t("expired")} />
              <br />
              <br />
              <p>{this.state.modal_message}</p>
              {/* <button
                className="btn btn-success btn-sm"
                // data-dismiss="modal"
                onClick={() => {
                  this.setState({
                    isTabActive: true,
                    isWindowChange: false,
                    modal_message: "",
                  });
                }}
              >
                <Translate value="close" />
              </button> */}
              <div className="button-wrap">
                <Button
                  variant="primary"
                  className="mt-3"
                  onClick={() => {
                    this.setState({
                      isTabActive: true,
                      isWindowChange: false,
                      modal_message: "",
                    });
                  }}
                >
                  <Translate value="close" />
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.show_error_modal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <div className="text-center mt-5 mb-5">
              <img src={warningIcon} className="icon" alt={i18n.t("expired")} />
              <br />
              <br />
              <p>{this.state.modal_message}</p>
              {/* <button
                className="btn btn-success btn-sm"
                // data-dismiss="modal"
                onClick={() => {
                  this.setState({
                    show_error_modal: false,
                    modal_message: "",
                  });
                  if (this.state.redirect_to_url) {
                    window.location.href = this.state.redirect_url;
                  }
                }}
              >
                <Translate value="close" />
              </button> */}
              <div className="button-wrap">
                <Button
                  variant="primary"
                  className="mt-3"
                  onClick={() => {
                    this.setState({
                      show_error_modal: false,
                      modal_message: "",
                    });
                    if (this.state.redirect_to_url) {
                      window.location.href = this.state.redirect_url;
                    }
                  }}
                >
                  <Translate value="close" />
                </Button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.show_key_code_modal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <div className="text-center mt-5 mb-5">
              <form onSubmit={this.handleCheckInviteCode} method="POST">
                <div className="form-group">
                  <label htmlFor="txtInviteCode" id="lblInviteCode">
                    <Translate value="enter_code" />
                  </label>
                  <input
                    autoFocus
                    type="text"
                    className="form-control"
                    id="txtInviteCode"
                    name="invite_code"
                    placeholder={i18n.t("h_invite")}
                    onChange={this.handleKeyCodeChange}
                    required
                  />
                </div>
                {/* <button
                  type="button"
                  id="btnInviteCode"
                  className="btn btn-primary"
                  onClick={this.handleCheckInviteCode}
                >
                  <Translate value="submit" />
                </button> */}
                <div className="button-wrap">
                  <Button
                    variant="primary"
                    id="btnInviteCode"
                    className="mt-3"
                    onClick={this.handleCheckInviteCode}
                  >
                    <Translate value="submit" />
                  </Button>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.show_email_verification_modal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <div className="mt-5 mb-5">
              <form>
                <div className="form-group text-center">
                  <h2>
                    <Translate value="ass_url" />
                  </h2>

                  <div className="row h-auto justify-content-center align-items-center px-4 py-5">
                    <p>
                      <Translate value="txt_email" />
                    </p>
                  </div>
                  <div className="form-group">
                    <p className="est text-left mb-1">{i18n.t("h_email")}: </p>
                    <input
                      type="text"
                      className="form-control"
                      id="txtEmail"
                      name="email"
                      onChange={this.handleEmailChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <p className="est text-left mb-1">
                      {i18n.t("h_reemail")}:{" "}
                    </p>
                    <input
                      type="text"
                      className="form-control"
                      id="txtValidateEmail"
                      name="validate_email"
                      onChange={this.handleValidateEmailChange}
                      required
                    />
                  </div>
                </div>
                {/* <button
                  type="button"
                  className="btn btn-primary mt-3"
                  onClick={this.handleEmailVerification}
                >
                  <Translate value="next" />
                </button> */}
                <div className="button-wrap">
                  <Button
                    variant="primary"
                    className="mt-3 btn-block"
                    onClick={this.handleEmailVerification}
                  >
                    <Translate value="next" />
                  </Button>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.show_language_selection_modal}
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body>
            <div className="mt-3 mb-3 mx-4">
              <form>
                <div className="form-group text-center">
                  <div className="form-group">
                    <h6>
                      <p className="est text-left mb-1">
                        Please select language:{" "}
                      </p>
                    </h6>
                    <br />
                    <select
                      className="form-control
                                            languages"
                      name="language"
                      onChange={this.handleLanguageChange}
                    >
                      {langugeOptions}
                    </select>
                  </div>
                </div>
                <br />
                {/* <button
                  type="button"
                  className="btn btn-primary mt-3"
                  onClick={this.showEmailVerificationModal}
                >
                  Next
                </button> */}
                <div className="button-wrap">
                  <Button
                    variant="primary"
                    className="mt-3"
                    onClick={this.showEmailVerificationModal}
                  >
                    Next
                  </Button>
                </div>
              </form>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={this.props.assessment.show_modal}
          aria-labelledby="api-error-modal-title"
          role="alertdialog"
          aria-modal="true"
          centered
        >
          <Modal.Body>
            <div className="text-center mt-5 mb-5">
              <img src={warningIcon} className="icon" alt="" />
              <br />
              <br />
              <h2 id="api-error-modal-title" className="sr-only">Error</h2>
              <p>{this.props.assessment.modal_text}</p>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  view: state.assessment.view,
  status: state.assessment.status,
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  setLocaleWithFallback: (lang) => dispatch(setLocaleWithFallback(lang)),
  start: () => dispatch(start()),
  changeView: (view) => dispatch(changeView(view)),
  setlanguage: (lang) => dispatch(setlanguage(lang)),
  setToErrorStatus: (errorstatus) => dispatch(setToErrorStatus(errorstatus)),
  setKeyAndCode: (key, code) => dispatch(setKeyAndCode(key, code)),
  setStatus: (status) => dispatch(setStatus(status)),
  setCheatCount: (count) => dispatch(setCheatCount(count)),
  initializeTest: (
    exam_id,
    tester_id,
    demographic_fields,
    sport_demographic_fields,
    sessions,
    exams,
    total_question,
    approximate_time,
    last_session_info,
    redirect_url,
    dist_url,
    candidate_consent,
    platform_logo,
    client_platform_logo,
    browser_info,
    has_security_features,
    has_job_application,
    enabled_open_question,
    open_questions,
  ) =>
    dispatch(
      initializeTest(
        exam_id,
        tester_id,
        demographic_fields,
        sport_demographic_fields,
        sessions,
        exams,
        total_question,
        approximate_time,
        last_session_info,
        redirect_url,
        dist_url,
        candidate_consent,
        platform_logo,
        client_platform_logo,
        browser_info,
        has_security_features,
        has_job_application,
        enabled_open_question,
        open_questions,
      ),
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
